const Config = {
  apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8055/api-dashboard' : 'https://gapps.soustitreur.com/api-dashboard',
  googleApiKey: "AIzaSyDvCMV2jq2-u4TzAfzP0h74YmKkQg4Wi-4",
};

export default Config;
